import { MatDialog } from '@angular/material';
import { ArchiveEnvironmentDialogComponent } from './archive-environment-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
var ArchiveEnvironmentDialogService = /** @class */ (function () {
    function ArchiveEnvironmentDialogService(matDialog) {
        this.matDialog = matDialog;
    }
    ArchiveEnvironmentDialogService.prototype.open = function (data) {
        return this.matDialog.open(ArchiveEnvironmentDialogComponent, {
            autoFocus: false,
            data: data
        }).afterClosed()
            .toPromise();
    };
    ArchiveEnvironmentDialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ArchiveEnvironmentDialogService_Factory() { return new ArchiveEnvironmentDialogService(i0.ɵɵinject(i1.MatDialog)); }, token: ArchiveEnvironmentDialogService, providedIn: "root" });
    return ArchiveEnvironmentDialogService;
}());
export { ArchiveEnvironmentDialogService };
